import React, { Component } from 'react';
import * as ReactDOM from 'react-dom';

export const SelectAlignment = {
  LEFT: 'left',
  RIGHT: 'right'
};

// TODO: implement horizontal alignment and custom item renderer

class Option extends Component {
  didClick = () => {
    this.props.onChange(this.props.value);
  };
  render() {
    return (
      <div
        onClick={this.didClick}
        className={
          'bf-select-option' +
          (this.props.selected ? ' bf-select-option--selected' : '')
        }
      >
        {this.props.children}
      </div>
    );
  }
}

export default class extends Component {
  constructor(props) {
    super(props);

    this.popover = React.createRef();
    this.state = {
      isOpen: false
    };
  }
  didClickOnWindow = e => {
    if (this.popover.current) {
      if (!this.popover.current.contains(e.target)) {
        this.setState({ isOpen: false });
      }
    }
  };
  open = event => {
    setTimeout(() => {
      this.setState({ isOpen: true });
    }, 1);
  };
  didChange = value => {
    this.props.onChange(value);
    if (this.props.shouldBeDismissedOnSelect) {
      this.setState({ isOpen: false });
    }
  };
  componentDidUpdate(prevProps, prevState) {
    if (prevState.isOpen !== this.state.isOpen && this.state.isOpen) {
      // positionate window
      if (this.popover.current) {
        const { left, top, width } =
          ReactDOM.findDOMNode(this).getBoundingClientRect();
        const el = this.popover.current;
        const box = el.getBoundingClientRect();
        el.style.left = `${left}px`;
        if (box.width < width) {
          el.style.width = `${width}px`;
        }
        if (box.bottom > window.innerHeight) {
          // move up
          el.style.bottom = `${window.innerHeight - top}px`;
        }
      }
    }
    if (prevState.isOpen !== this.state.isOpen) {
      if (this.state.isOpen) {
        window.addEventListener('mousedown', this.didClickOnWindow);
      } else {
        window.removeEventListener('mousedown', this.didClickOnWindow);
      }
    }
  }
  componentWillUnmount() {
    window.removeEventListener('mousedown', this.didClickOnWindow);
  }

  render() {
    const format = value => {
      if (this.props.formatValue) {
        return this.props.formatValue(value);
      }
      return value;
    };
    return (
      <div
        className={
          'bf-select' +
          (this.state.isOpen ? ' bf-select--open' : '') +
          (this.props.options.length > 10 ? ' bf-select--long' : '')
        }
        onMouseDown={this.state.isOpen ? null : this.open}
      >
        {format(this.props.value)}
        {this.state.isOpen && (
          <div className="bf-select-popover" ref={this.popover}>
            {this.props.options.map(opt => {
              return (
                <Option
                  key={opt}
                  value={opt}
                  onChange={this.didChange}
                  selected={opt === this.props.value}
                >
                  {format(opt)}
                </Option>
              );
            })}
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Select.js